import React, { use, useEffect, useState } from "react";
import { getUserFromToken } from "../../../../utils/functions.ts";
import { getTodayEasternYMD } from "../../../../utils/dateUtils.ts";
import { useNavigate } from "react-router-dom";
import { usePlayer } from "../../../../Contexts/playerData.context";
import SimpleCelendar from "../../../Universals/FBXCalendar/simpleCalendar.component.jsx"

const EditHWSBox = ({ currentPlayer }) => {

     const { playerData, setPlayerData, setActivePlayer } = usePlayer();
     const navigate = useNavigate();
     const [showHWSHistory, setShowHWSHistory] = useState(false);
     const [showEditHWSHistory, setShowEditHWSHistory] = useState(false);
     const [showEditIndiRecord, setShowEditIndiRecord] = useState(false);
     const [hwsData, setHWSData] = useState([])
     const [myAccount, setMyAccount] = useState([]);
     const [currentHWSData, setCurrentHWSData] = useState({
          HWSId: '',
          height: '',
          heightV: '',
          heightDate: '0000-00-00',
          weight: '',
          weightV: '',
          weightDate: '0000-00-00',
          speed40Fastest: '',
          speed40FVerified: '',
          speed40FDate: '0000-00-00',
          speed40FSurface: '',
          speed40FSource: '',
          speed40FNote: '',
          visibleTo: '',
          byWho: '',
          hwsNote: '',
     });

     const [currentIndiHWSData, setCurrentIndiHWSData] = useState({
          height: '',
          heightV: '',
          heightDate: '0000-00-00',
          weight: '',
          weightV: '',
          weightDate: '0000-00-00',
          speed40Fastest: '',
          speed40FVerified: '',
          speed40FDate: '0000-00-00',
          speed40FSurface: '',
          hwsNote: '',
     });

     const [newHWSData, setNewHWSData] = useState({
          height: '',
          heightV: '',
          heightDate: '',
          weight: '',
          weightV: '',
          weightDate: '',
          speed40Fastest: '',
          speed40FVerified: '',
          speed40FDate: '',
          speed40FSurface: '',
          hwsNote: '',
     });



     const getHWSData = async (fbxid) => {
          try {
               const user = await getUserFromToken();
               if (!user || (Array.isArray(user) && user.length === 0)) {
                    navigate("/login");
                    return;
               }

               const response = await fetch("https://www.fbxchange.com/ReactPHP/hdbox.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                         FBXID: fbxid,
                         myTeam: user.team,
                         script: "getHWSHIstoryData",
                    }),
               });

               const data = await response.json();
               setHWSData(data);
               setShowHWSHistory(true);
               setShowEditHWSHistory(false);
          } catch (error) {
               console.error("Error fetching data:", error);
          }
     };

     const toggleEditHWSHistory = () => {
          if (showEditHWSHistory) {
               setShowEditHWSHistory(false);
               setShowEditIndiRecord(false);
          } else {
               setShowEditHWSHistory(true);
               setShowHWSHistory(false);
               setShowEditIndiRecord(false);
          }
     }

     const toggleHWSHistory = () => {
          setShowEditIndiRecord(false);
          if (showHWSHistory) {
               setShowHWSHistory(false);
          } else {
               getHWSData(currentPlayer.FBXID);
          }
     };

     useEffect(() => {
          setShowHWSHistory(false);
          setShowEditIndiRecord(false);
          if (currentPlayer) {
               setCurrentHWSData({
                    height: currentPlayer.height || '',
                    heightV: currentPlayer.heightV || '',
                    heightDate: currentPlayer.heightDate || '0000-00-00',
                    weight: currentPlayer.weight || '',
                    weightV: currentPlayer.weightV || '',
                    weightDate: currentPlayer.weightDate || '0000-00-00',
                    speed40Fastest: currentPlayer.speed40Fastest || '',
                    speed40FVerified: currentPlayer.speed40FVerified || '',
                    speed40FDate: currentPlayer.speed40FDate || '0000-00-00',
                    speed40FSurface: currentPlayer.speed40FSurface || '',
                    visibleTo: currentPlayer.visibleTo || '',
                    byWho: currentPlayer.byWho || '',
                    hwsNote: currentPlayer.hwsNote || '',
               });
          }

          const fetchUser = async () => {
               const user = await getUserFromToken();
               setMyAccount(user);
          };

          fetchUser();
     }, [currentPlayer]);


     const changeToEditHWS = (inval) => {
          if (myAccount.displayName !== inval.byWhoCode) {
               return
          }
          setCurrentIndiHWSData({
               HWSId: inval.HWSId || '',
               height: inval.HEIGHT || '',
               heightV: inval.Height_V || '',
               heightDate: inval.HeightDate || '0000-00-00',
               weight: inval.WEIGHT || '',
               weightV: inval.Weight_V || '',
               weightDate: inval.weightdate || '0000-00-00',
               speed40Fastest: inval.SPEED40FASTEST || '',
               speed40FVerified: inval.Speed40_F_Verified || '',
               speed40FDate: inval.speeddate || '0000-00-00',
               speed40FSurface: inval.Speed40_F_Surface || '',
               hwsNote: inval.hwsNote || '',
          });
          setShowEditIndiRecord(true);
     };

     const resetToFBX = () => {
          setCurrentIndiHWSData({
               height: currentPlayer.height || '',
               heightV: currentPlayer.heightV || '',
               heightDate: currentPlayer.heightDate || '0000-00-00',
               weight: currentPlayer.weight || '',
               weightV: currentPlayer.weightV || '',
               weightDate: currentPlayer.weightDate || '0000-00-00',
               speed40Fastest: currentPlayer.speed40Fastest || '',
               speed40FVerified: currentPlayer.speed40FVerified || '',
               speed40FDate: currentPlayer.speed40FDate || '0000-00-00',
               speed40FSurface: currentPlayer.speed40FSurface || '',
               hwsNote: `Reset to FBX Data ${getTodayEasternYMD()}`,
          });
     }

     const cancelNewHWS = () => {
          setNewHWSData({
               height: '',
               heightV: '',
               heightDate: '',
               weight: '',
               weightV: '',
               weightDate: '',
               speed40Fastest: '',
               speed40FVerified: '',
               speed40FDate: '',
               speed40FSurface: '',
               hwsNote: '',
          });
          setShowEditHWSHistory(false);
     };

     const saveNewHWS = async () => {
          const user = await getUserFromToken();
          if (!user || (Array.isArray(user) && user.length === 0)) {
               navigate("/login");
               return;
          }
          const response = await fetch("https://www.fbxchange.com/ReactPHP/hdbox.php", {
               method: "POST",
               headers: { "Content-Type": "application/json" },
               body: JSON.stringify({
                    FBXID: currentPlayer.FBXID,
                    myTeam: user.team,
                    security: user.userContactLevel,
                    displayName: user.displayName,
                    script: "addNewHWS",
                    newHWSData: {
                         ...newHWSData,
                         byWhoCode: user.displayName,
                         visibleTo: user.team,
                    }
               }),
          });
          const data = await response.json();
          if (data) {
               const updatedPlayerData = playerData.map(player => {
                    if (player.FBXID === currentPlayer.FBXID) {
                         return {
                              ...player,
                              height: data.HEIGHT || '',
                              heightV: data.HEIGHT_V || '',
                              heightDate: data.HEIGHTDATE || '0000-00-00',
                              weight: data.WEIGHT || '',
                              weightV: data.WEIGHT_V || '',
                              weightDate: data.WEIGHTDATE || '0000-00-00',
                              speed40Fastest: data.SPEED40FASTEST || '',
                              speed40FVerified: data.SPEED40_F_VERIFIED || '',
                              speed40FDate: data.SPEED40_F_DATE || '0000-00-00',
                              speed40FSurface: data.SPEED40_F_SURFACE || '',
                              hwsNote: data.hwsNote || '',
                         };
                    } else {
                         return player;
                    }
               });
               setPlayerData(updatedPlayerData);
               const updatedPlayer = updatedPlayerData.find(player => player.FBXID === currentPlayer.FBXID);
               setActivePlayer(updatedPlayer);

               setNewHWSData({
                    height: '',
                    heightV: '',
                    heightDate: '',
                    weight: '',
                    weightV: '',
                    weightDate: '',
                    speed40Fastest: '',
                    speed40FVerified: '',
                    speed40FDate: '',
                    speed40FSurface: '',
                    hwsNote: '',
               });
               setShowEditHWSHistory(false);
          }
     }

     const saveTheUpdatedRecord = async () => {
          try {
               const response = await fetch("https://www.fbxchange.com/ReactPHP/hdbox.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                         script: "updateHWSRecord",
                         currentIndiHWSData: {
                              ...currentIndiHWSData,
                         }
                    }),
               });
               const result = await response.json();
               if (result && result.status === true) {
                    // Refresh HWS data and close edit mode
                    await getHWSData(currentPlayer.FBXID);
                    setShowEditIndiRecord(false);
               } else {
                    // Handle error or show message
                    alert("Failed to update record.");
               }
          } catch (error) {
               console.error("Error sending data:", error);
               alert("Error updating record.");
          }
     }


     return (
          <>
               {!showEditHWSHistory && (
                    <div className="w-100 p-3">
                         <div className="col-36 offset-6">
                              <div className="d-flex col-48 gap-2 py-1">
                                   <div className="col-10 offset-5 text-end pe-3">Height: {currentPlayer?.height}</div>
                                   <div className="col-3">{currentPlayer?.heightV}</div>
                                   <div className="col-10">{currentPlayer?.heightDate !== '0000-00-00' ? currentPlayer?.heightDate : '-'}</div>
                                   <div className="flex-grow-1">Source in History</div>
                              </div>
                              <div className="d-flex col-48 gap-2 py-1">
                                   <div className="col-10 offset-5 text-end pe-3">Weight: {currentPlayer?.weight}</div>
                                   <div className="col-3">{currentPlayer?.weightV}</div>
                                   <div className="col-10">{currentPlayer?.weightDate !== '0000-00-00' ? currentPlayer?.weightDate : '-'}</div>
                                   <div className="flex-grow-1">Source in History</div>
                              </div>
                              <div className="d-flex col-48 gap-2 py-1">
                                   <div className="col-10 offset-5 text-end pe-3">Speed: {currentPlayer?.speed40Fastest}</div>
                                   <div className="col-3">{currentPlayer?.speed40FVerified}</div>
                                   <div className="col-10">{currentPlayer?.speed40FDate !== '0000-00-00' ? currentPlayer?.speed40FDate : '-'}</div>
                                   <div className="flex-grow-1">Surface: {currentPlayer?.speed40FSurface}</div>
                              </div>
                         </div>
                    </div>)}

               <div className="mt-3 col-36 offset-6 d-flex gap-2 justify-content-center">
                    <div className="col-23">
                         <div
                              className={`btn w-100 ${showHWSHistory ? "btn-warning" : "btn-outline-navy"}`}
                              onClick={toggleHWSHistory}
                         >
                              View/Edit HWS History
                         </div>
                    </div>
                    <div className="col-23">
                         <div
                              className={`btn w-100 ${showEditHWSHistory ? "btn-warning" : "btn-outline-navy"}`}
                              onClick={toggleEditHWSHistory}
                         >
                              Add New HWS
                         </div>
                    </div>
               </div>

               {showHWSHistory && (
                    <>
                         {!showEditIndiRecord ? (
                              <div className="col-48 py-1 ">
                                   <div>
                                        <h5 className="text-center">Edit <span className="text-danger">Your</span> HWS in <span className="text-danger">History</span> by Pressing on 'By' Button</h5>
                                   </div>
                                   <div className="d-flex col-48 gap-2 py-1 border-bottom border-1 border-secondary bg-navy text-lemon">
                                        <div className="d-flex col-7 gap-2">
                                             <div className="col-46 ps-3 text-start">Height</div>
                                        </div>
                                        <div className="d-flex col-7 gap-2">
                                             <div className="col-46 ps-3 text-start">Weight</div>
                                        </div>
                                        <div className="d-flex col-7 gap-2">
                                             <div className="col-46 ps-3 text-start">Speed</div>
                                        </div>
                                        <div
                                             className="flex-grow-1 text-truncate ps-3">
                                             <div className="col-48 overflow-hidden text-nowrap">
                                                  HWS Note
                                             </div>
                                        </div>
                                        <div className="col-3 text-center">Team</div>
                                        <div className="col-3 text-center">By</div>
                                   </div>
                                   <div className="col-48 fs-8">
                                        {hwsData.map((data, index) => (
                                             <div key={index} className="d-flex col-48 gap-2 py-1 border-bottom border-1 border-secondary align-items-center">
                                                  <div className="d-flex col-7 gap-4" style={{ fontSize: 'x-small' }}>
                                                       <div className="col-46 ps-3 text-start">{data?.HEIGHT || '-'} {data?.Height_V || '-'} {data?.HeightDate !== '0000-00-00' ? data?.HeightDate : '-'}</div>

                                                  </div>
                                                  <div className="d-flex col-7 gap-4" style={{ fontSize: 'x-small' }}>
                                                       <div className="col-46 ps-3 text-start">{data?.WEIGHT || '-'} {data?.Weight_V || '-'} {data?.weightdate !== '0000-00-00' ? data?.weightdate : '-'}</div>
                                                  </div>
                                                  <div className="d-flex col-7 gap-2" style={{ fontSize: 'x-small' }}>
                                                       <div className="col-46 ps-3 text-start">{data?.SPEED40FASTEST || '-'} {data?.Speed40_F_Verified || '-'} {data?.speeddate !== '0000-00-00' ? data?.speeddate : '-'}</div>
                                                  </div>
                                                  <div
                                                       className="flex-grow-1 text-truncate ps-3"
                                                       style={{ fontSize: 'x-small' }}
                                                       title={data?.hwsNote}
                                                  >
                                                       <div className="col-48 overflow-hidden text-nowrap">
                                                            {data?.hwsNote || '-'}
                                                       </div>
                                                  </div>
                                                  <div className="col-3 text-center" style={{ fontSize: 'x-small' }}>{data.visibleTo}</div>
                                                  <div className="col-3">
                                                       <div
                                                            className={`btn btn-sm w-100 ${data.byWhoCode === myAccount.displayName ? 'btn-navy' : 'btn-light'}`}
                                                            style={{ fontSize: 'x-small' }}
                                                            onClick={() => changeToEditHWS(data)}
                                                       >
                                                            {data.byWhoCode}
                                                       </div>
                                                  </div>
                                             </div>
                                        ))}
                                   </div>
                              </div>
                         ) : (
                              <div className="alert alert-light">
                                   <div className="col-36 offset-6">
                                        {/* HEIGHT ROW */}
                                        <div className="d-flex col-48 gap-2 py-1 align-items-center">
                                             <div className="col-10 offset-5">
                                                  <input
                                                       className="form-control"
                                                       type="text"
                                                       placeholder="Height"
                                                       value={currentIndiHWSData.height}
                                                       onChange={(e) => {
                                                            setCurrentIndiHWSData(prev => ({ ...prev, height: e.target.value }));
                                                       }}
                                                  />
                                             </div>
                                             <div className="col-3">
                                                  <input
                                                       className="form-control"
                                                       type="text"
                                                       placeholder="Verified"
                                                       value={currentIndiHWSData.heightV}
                                                       onChange={(e) => setCurrentIndiHWSData(prev => ({ ...prev, heightV: e.target.value }))}
                                                  />
                                             </div>
                                             <div className="col-10">
                                                  <SimpleCelendar
                                                       onDateChange={(date) => setCurrentIndiHWSData(prev => ({ ...prev, heightDate: date }))}
                                                       dateIn={currentIndiHWSData.heightDate !== '0000-00-00' ? currentIndiHWSData.heightDate : ''}
                                                       placeholder="yyyy-mm-dd"
                                                       className="form-control"
                                                  />

                                             </div>
                                        </div>


                                        {/* WEIGHT ROW */}
                                        <div className="d-flex col-48 gap-2 py-1 align-items-center">
                                             <div className="col-10 offset-5">
                                                  <input
                                                       className="form-control pe-3"
                                                       type="text"
                                                       placeholder="Weight"
                                                       value={currentIndiHWSData.weight}
                                                       onChange={(e) => setCurrentIndiHWSData(prev => ({ ...prev, weight: e.target.value }))}
                                                  />
                                             </div>
                                             <div className="col-3">
                                                  <input
                                                       className="form-control"
                                                       type="text"
                                                       placeholder="Verified"
                                                       value={currentIndiHWSData.weightV}
                                                       onChange={(e) => setCurrentIndiHWSData(prev => ({ ...prev, weightV: e.target.value }))}
                                                  />
                                             </div>
                                             <div className="col-10">
                                                  <SimpleCelendar
                                                       onDateChange={(date) => setCurrentIndiHWSData(prev => ({ ...prev, weightDate: date }))}
                                                       dateIn={currentIndiHWSData.weightDate !== '0000-00-00' ? currentIndiHWSData.weightDate : ''}
                                                       placeholder="yyyy-mm-dd"
                                                       className="form-control"
                                                  />
                                             </div>

                                        </div>

                                        {/* SPEED ROW */}
                                        <div className="d-flex col-48 gap-2 py-1">
                                             <div className="col-10 offset-5">
                                                  <input
                                                       className="form-control pe-3"
                                                       type="text"
                                                       placeholder="Speed 40"
                                                       value={currentIndiHWSData.speed40Fastest}
                                                       onChange={(e) => setCurrentIndiHWSData(prev => ({ ...prev, speed40Fastest: e.target.value }))}
                                                  />
                                             </div>
                                             <div className="col-3">
                                                  <input
                                                       className="form-control"
                                                       type="text"
                                                       placeholder="Verified"
                                                       value={currentIndiHWSData.speed40FVerified}
                                                       onChange={(e) => setCurrentIndiHWSData(prev => ({ ...prev, speed40FVerified: e.target.value }))}
                                                  />
                                             </div>
                                             <div className="col-10">
                                                  <SimpleCelendar
                                                       onDateChange={(date) => setCurrentIndiHWSData(prev => ({ ...prev, speed40FDate: date }))}
                                                       dateIn={currentIndiHWSData.speed40FDate !== '0000-00-00' ? currentIndiHWSData.speed40FDate : ''}
                                                       placeholder="yyyy-mm-dd"
                                                       className="form-control"
                                                  />
                                             </div>
                                             <div className="col-6">
                                                  <input
                                                       className="form-control"
                                                       type="text"
                                                       placeholder="Surface"
                                                       value={currentIndiHWSData.speed40FSurface}
                                                       onChange={(e) => setCurrentIndiHWSData(prev => ({ ...prev, speed40FSurface: e.target.value }))}
                                                  />
     
                                             </div>
                                        </div>
                                        <div className="col-48 mt-1 d-flex gap-2 mb-3">
                                             <div className="col-30 offset-5">
                                                  <input
                                                       className="form-control pe-3"
                                                       type="text"
                                                       placeholder="HWS Note"
                                                       value={currentIndiHWSData.hwsNote}
                                                       onChange={(e) => setCurrentIndiHWSData(prev => ({ ...prev, hwsNote: e.target.value }))}
                                                  />
                                             </div>
                                        </div>
                                        <div className="flex-grow-1 d-flex justify-content-center align-items-center gap-2">
                                             <div className="col-16">
                                                  <div className="btn btn-danger btn-sm w-100" onClick={() => setShowEditIndiRecord(false)}>Cancel</div>
                                             </div>
                                             <div className="col-16">
                                                  <div className="btn btn-primary btn-sm w-100" onClick={() => resetToFBX()}>Reset to Current FBX Data</div>
                                             </div>
                                             <div className="col-16">
                                                  <div className="btn btn-success btn-sm w-100 text-light" onClick={() => saveTheUpdatedRecord()} >Save to HWS</div>
                                             </div>
                                        </div>

                                   </div>
                              </div>
                         )}
                    </>
               )}

               {showEditHWSHistory && (
                    <div id="AddNewHwS" className="col-48 py-1 ">
                         <div className="alert-purple p-3 col-36 offset-6 mb-1">
                              <h5 className="text-center">New HWS Warning</h5>
                              <div className="text-center fs-7">Changing the HWS will change the Data for Your Team for all users. This propriety data will become the new HWS for this player</div>
                         </div>
                         <div className="col-36 offset-6">
                              {/* HEIGHT ROW */}
                              <div className="d-flex col-48 gap-2 align-items-center">
                                   <div className="col-10 offset-5">
                                        <input
                                             className="form-control"
                                             type="text"
                                             placeholder="Height"
                                             onChange={(e) => setNewHWSData(prev => ({ ...prev, height: e.target.value }))}
                                             value={newHWSData.height}
                                        />
                                   </div>
                                   <div className="col-3">
                                        <input
                                             className="form-control"
                                             type="text"
                                             placeholder="V"
                                             onChange={(e) => setNewHWSData(prev => ({ ...prev, heightV: e.target.value }))}
                                             value={newHWSData.heightV}
                                        />
                                   </div>
                                   <div className="col-10">

                                        <SimpleCelendar
                                             onDateChange={(date) => setNewHWSData(prev => ({ ...prev, heightDate: date }))}
                                             value={newHWSData.heightDate}
                                             placeholder="yyyy-mm-dd"
                                             className="form-control"
                                             dateFormat="yyyy-mm-dd"
                                             showTimeSelect={false}
                                        />
                                   </div>
                              </div>


                              {/* WEIGHT ROW */}
                              <div className="d-flex col-48 gap-2 align-items-center">
                                   <div className="col-10 offset-5">
                                        <input
                                             className="form-control pe-3"
                                             type="text"
                                             placeholder="Weight"
                                             onChange={(e) => setNewHWSData(prev => ({ ...prev, weight: e.target.value }))}
                                             value={newHWSData.weight}
                                        />
                                   </div>
                                   <div className="col-3">
                                        <input
                                             className="form-control"
                                             type="text"
                                             placeholder="V"
                                             onChange={(e) => setNewHWSData(prev => ({ ...prev, weightV: e.target.value }))}
                                             value={newHWSData.weightV}
                                        />
                                   </div>
                                   <div className="col-10">
                                        <SimpleCelendar
                                             onDateChange={(date) => setNewHWSData(prev => ({ ...prev, weightDate: date }))}
                                             value={newHWSData.weightDate}
                                             placeholder="yyyy-mm-dd"
                                             className="form-control"
                                             dateFormat="yyyy-mm-dd"
                                             showTimeSelect={false}
                                        />
                                   </div>

                              </div>
                              {/* SPEED ROW */}
                              <div className="d-flex col-48 gap-2">
                                   <div className="col-10 offset-5">
                                        <input
                                             className="form-control pe-3"
                                             type="text"
                                             placeholder="Speed 40"
                                             disabled={false}
                                             onChange={(e) => setNewHWSData(prev => ({ ...prev, speed40Fastest: e.target.value }))}
                                             value={newHWSData.speed40Fastest}
                                        />
                                   </div>
                                   <div className="col-3">
                                        <input
                                             className="form-control"
                                             type="text"
                                             placeholder="V"
                                             onChange={(e) => setNewHWSData(prev => ({ ...prev, speed40FVerified: e.target.value }))}
                                             value={newHWSData.speed40FVerified}
                                        />
                                   </div>
                                   <div className="col-10">
                                        <SimpleCelendar
                                             onDateChange={(date) => setNewHWSData(prev => ({ ...prev, speed40FDate: date }))}
                                             value={newHWSData.speed40FDate}
                                             placeholder="yyyy-mm-dd"
                                             className="form-control"
                                             dateFormat="yyyy-mm-dd"
                                             showTimeSelect={false}
                                        />
                                   </div>
                                   <div className="col-6">
                                        <input
                                             className="form-control"
                                             type="text"
                                             placeholder="Surface"
                                             value={newHWSData.speed40FSurface}
                                             onChange={(e) => setNewHWSData(prev => ({ ...prev, speed40FSurface: e.target.value }))}
                                        />
                                   </div>
                              </div>

                              <div className="col-48 mt-1 d-flex gap-2">
                                   <div className="col-30 offset-5">
                                        <input
                                             className="form-control pe-3"
                                             type="text"
                                             placeholder="HWS Note"
                                             value={newHWSData.hwsNote}
                                             onChange={(e) => setNewHWSData(prev => ({ ...prev, hwsNote: e.target.value }))}
                                        />
                                   </div>
                                   <div className="flex-grow-1 d-flex justify-content-center align-items-center gap-2">
                                        <div className="col-23">
                                             <div className="btn btn-danger btn-sm w-100" onClick={() => cancelNewHWS()}>Cancel</div>
                                        </div>
                                        <div className="col-23">
                                             <div className="btn btn-success btn-sm w-100 text-light" onClick={() => saveNewHWS()}>Save</div>
                                        </div>
                                   </div>
                              </div>

                         </div>
                    </div>

               )}
          </>
     );
};

export default EditHWSBox;
